var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('headerDiv'),_vm._v(" "),_c('div',{staticClass:"bg-color"},[_c('div',{staticClass:"middler-wrapper"},[_c('sideDiv'),_vm._v(" "),_c('mainDiv')],1)]),_vm._v(" "),_c('footerDiv')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77a08a88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/index.vue
// module id = null
// module chunks = 